import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import '@/utils/vant-ui' // 导入 vant 组件
import 'core-js/stable' // 引入所有稳定版的 polyfill
import store from './store'
import './assets/styles/variables.less' // 引入全局变量文件
import './assets/fonts/iconfont/iconfont.css' // 引入全局变量文件

import './utils/globalMethods' // 引入公共方法类
import Login from './components/Login.vue' // 引入登录公共组件
import LuckyRoulette from './components/LuckyRoulette.vue' // 引入登录公共组件
import CommonPopup from './components/CommonPopup.vue' // 引入弹窗公共组件
import TitleBar from './components/TitleBar.vue' // 引入弹窗公共组件
import ServicePopup from './components/ServicePopup.vue' // 引入弹窗人工客服
import ActivityPopup from './components/ActivityPopup.vue' // 活动弹窗
import RechargeCont from './components/RechargeCont.vue' // 充值弹窗
import CommonSwiper from './components/CommonSwiper.vue'
import CommonLang from './components/CommonLang.vue'
// 引入 animate.css
// import 'animate.css'

import globalMixin from './utils/globalMixin'
import FacebookPixelPlugin from './utils/facebookPixelPlugin'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn' // 引入中文语言包
import VueLuckyCanvas from '@lucky-canvas/vue'
import VueI18n from 'vue-i18n'
import dragScroll from './utils/dragScroll'
import LotteryOrder from './components/LotteryOrder.vue' // 彩票订单
import LotteryDayHistory from './components/LotteryDayHistory.vue' // 彩票当天投注记录
Vue.directive('drag-scroll', dragScroll)
// import VConsole from 'vconsole'
// new VConsole()
dayjs.locale('zh-cn') // 使用中文语言包
// Vue.use(VueI18n)
// const messages = {
//   EN: require('../src/lang/en'),
//   PT: require('../src/lang/pt')
// }
// const i18n = new VueI18n({
//   locale: 'EN',
//   messages
// })
// Vue.prototype.$lang = messages['EN'].default

Vue.use(VueI18n)
const messages = {
  en: require('../src/lang/en'),
  fr: require('../src/lang/fr'),
  pt: require('../src/lang/pt')
}
const i18n = new VueI18n({
  locale: localStorage.getItem('defaultLanguage') || 'en',
  messages
})
const newValue = localStorage.getItem('defaultLanguage') || 'en'
Vue.prototype.$lang = messages[newValue].default
import Meta from 'vue-meta'

// Vue.prototype.$jumpTo = function (routeName, params = {}) {
//   // 获取本地存储的前缀
//   const prefix = localStorage.getItem('country') || ''
//   // 合并前缀参数和业务参数
//   const finalParams = {
//     ...params
//   }
//   // 跳转
//   this.$router.push({
//     path: '/' + prefix + routeName,
//     query: finalParams
//   })
// }

// 扩展 Vue 原型，添加支持 push/replace 的跳转方法
Vue.prototype.$jumpTo = function (routeName, params = {}, options = {}) {
  // 获取本地存储的前缀
  const prefix = localStorage.getItem('country') || ''
  // 合并前缀参数和业务参数
  const finalParams = {
    ...params
  }

  // 构建跳转配置
  const routeConfig = {
    path: '/' + prefix + routeName,
    query: finalParams
  }

  // 根据配置选择跳转方式：默认 push，可通过 replace: true 指定 replace
  const jumpMethod = options.replace ? 'replace' : 'push'

  // 执行跳转（增加异常捕获，避免重复跳转同一路由报错）
  try {
    this.$router[jumpMethod](routeConfig)
  } catch (error) {
    // 静默处理重复跳转的错误（也可根据需要添加日志）
    if (
      !error.message.includes(
        'Avoided redundant navigation to current location'
      )
    ) {
      console.error(error)
    }
  }
}

// 直接启动游戏（跳过 gameDetail 页，点击即进）
Vue.prototype.$launchGame = function (jumpPayload) {
  if (!jumpPayload) return
  if (jumpPayload.type === 'lottery') {
    this.$jumpTo('/lotteryDetail', {
      lotteryType: jumpPayload.lotteryType,
      lotteryName: jumpPayload.lotteryName,
      typeCate: jumpPayload.typeCate != null ? jumpPayload.typeCate : 1
    })
    return
  }
  const prefix = localStorage.getItem('country') || ''
  this.$router.push({
    name: 'GameHall',
    params: {
      prefix,
      gid: jumpPayload.gid,
      isDemo: jumpPayload.isDemo != null ? jumpPayload.isDemo : 0,
      from: jumpPayload.from || 'game',
      typeCate: jumpPayload.typeCate,
      gameTab: jumpPayload.gameTab
    }
  })
  localStorage.setItem('hallFrome', 'game')
  localStorage.setItem('hallGid', String(jumpPayload.gid))
}

Vue.use(Meta)
// console.log(messages, 888)

Vue.use(FacebookPixelPlugin)
Vue.use(VueLuckyCanvas)
Vue.prototype.$dayjs = dayjs
// 应用全局混入
Vue.mixin(globalMixin)
// 全局注册组件
Vue.component('CommonLang', CommonLang)
Vue.component('LotteryDayHistory', LotteryDayHistory)
Vue.component('LotteryOrder', LotteryOrder)
Vue.component('CommonSwiper', CommonSwiper)
Vue.component('RechargeCont', RechargeCont)
Vue.component('login', Login)
Vue.component('LuckyRoulette', LuckyRoulette)
Vue.component('CommonPopup', CommonPopup)
Vue.component('TitleBar', TitleBar)
Vue.component('ServicePopup', ServicePopup)
Vue.component('ActivityPopup', ActivityPopup)

Vue.prototype.$bus = new Vue()
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
